module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'returnSelection') ? _c('ReturnSelection', {
    on: {
      "setReturnDevice": _vm.getReturnDevice,
      "setReturnDrugStorage": _vm.getReturnDrugStorage
    }
  }) : _vm._e(), (_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum,
      "defaultPackCount": _vm.amountPayload.packCount,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_c('strong', [(this.currentDevice.specific_type === 'return_device') ? _c('span', [_vm._v("退至退藥盒")]) : (_vm.returnToEmptyDeviceId) ? _c('span', [_vm._v("退至空藥盒")]) : _c('span', [_vm._v("退至原藥盒")])])])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64af5bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnDrugFlow/ActionWrap.vue
// module id = 1492
// module chunks = 1